
<template>

  <div class="wrapper">
    <el-container>
<!--      <el-header>-->
<!--      </el-header>-->
      <el-main>
        <el-dropdown @command="handleCommand" ref="myDropdown" >
          <span class="el-dropdown-link" >
            <i class="el-icon-s-custom"></i>
          </span>
          <el-dropdown-menu slot="dropdown" class="menu_class">
            <el-dropdown-item command="userInfo" >{{user_info.username}}</el-dropdown-item>

            <el-dropdown-item command="delivery" >快递签收</el-dropdown-item>

            <el-dropdown-item command="goBack" >返回上一页</el-dropdown-item>

            <el-dropdown-item command="logout"  divided="divided" >退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <!--<keep-alive include="Check,B2bCheck">-->
          <router-view></router-view>
        <!--</keep-alive>-->
      </el-main>
    </el-container>
  </div>

</template>

<script>
// import vHeader from "./components/Header";
// import store from "../../store";

import {mapMutations, mapState} from "vuex";

export default {
  name: "Layout",
  components: {
    // vHeader

  },
  data: function () {
    return {
      param: {
      },
    }
  },
  computed: {
    ...mapState(['user_info']),
  },
  methods:{
    ...mapMutations(['setLogout','setUserInfo']),
    handleCommand(command) {
      this.$refs.myDropdown.hide();
      if(command == 'logout'){
        this.logout();
      }else if(command == 'goBack'){
        this.$router.back();
      }else if(command == 'delivery'){
        this.$router.push('/warehouse-delivery');
      }
    },
    logout(){
      this.http.fetchDel(this.api.logout).then((res)=>{
        console.log(res.data)
        if (res.data.code === 200) {
          this.setLogout();
          this.$router.push('/login');
        }else{
          this.$message.error('退出登陆失败');
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    getUserInfo(){
      this.http.fetchGet(this.api.user_info).then((res)=>{
            if(res.data.status==0){
              //强制下线
              this.setLogout();
              this.$router.push('/login');
            }
            var data=res.data;
            this.setUserInfo(data);
          }
      ).catch(err => {
        console.log(err)
      })
    }
  },
  created() {
    //获取用户信息
    this.getUserInfo();
  }
}

</script>

<style  lang="stylus" scoped >
@import '~@/assets/css/varibles.styl';
.el-header
  line-height $hdHeight
  height $hdHeight !important
  position relative
  left 0
  right 0
  top 0
  /*padding-bottom: 30px;*/
  -webkit-transition: left .3s ease-in-out
  transition: left .3s ease-in-out
  background: #3879ed
  color #fff
  padding 0 10px

.el-main{
    padding: 10px
  }
.el-header .text-center{
  text-align: right;

}
.el-header .text-left{
  text-align: left;
}
.el-dropdown {
  display: inline-block;
  position: absolute;
  color: #606266;
  font-size: 30px;
  width: 30px;
  z-index: 9;
}

.el-dropdown-link {
  cursor: pointer;
  //color: #409EFF;
}
.el-icon-arrow-down {
  font-size: 12px;
}

.search-box{
  width: cacl(100% - 30px)!important;
  margin-left:30px!important ;
}
</style>
